import * as React from "react";
const ClothesCorporateMaleGreyGreen = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<defs>
			<style>
				{
					".cls-corp-m-grey-green-1{fill:none;}.cls-corp-m-grey-green-2{fill:#282b2e;}.cls-corp-m-grey-green-3{fill:#162f4b;}.cls-corp-m-grey-green-4{clip-path:url(#clip-path-corp-m-grey-green);}.cls-corp-m-grey-green-5{fill:#3c8a7d;}.cls-corp-m-grey-green-6{fill:#5d5d5d;}"
				}
			</style>
			<clipPath id="clip-path-corp-m-grey-green">
				<path
					className="cls-corp-m-grey-green-1"
					d="M715.2,553.33s13,111.1,14.14,114.06c9.55.86,76.74-42.95,76.74-42.95,0-8.42-24.75-180.1-29.84-195.3-4.94-14.77-21.12-29.59-31.57-35.78-7.68-4.55-90.51-40-101-44.2,0-2.11,0-4.21-2.11-8.42C637.32,336.53,618,326,618,326c0,9,0,11,10,20-.42,15.13-7.52,26.31-22.25,45.25s-42.1,16.84-42.1,16.84-27.36,2.11-42.09-16.84S499.42,361.13,499,346c7-6,11-12,9-18,0,0-18,8.53-22.23,12.74-2.1,4.21-2.1,6.31-2.1,8.42-10.53,4.21-93.35,39.65-101,44.2-10.44,6.19-26.63,21-31.57,35.78C346,444.34,319.22,616,319.22,624.44c0,0,67.19,43.81,76.75,42.95,1.13-3,16.13-114.06,16.13-114.06s4.21,256.79-2.1,284.15-4.21,109.46-4.21,109.46,75.77,37.89,157.86,37.89,157.87-37.89,157.87-37.89,2.1-82.09-4.21-109.46S715.2,553.33,715.2,553.33Z"
				/>
			</clipPath>
		</defs>
		<title>{"corporate m gris et vert"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-corp-m-grey-green-1" width={1080} height={1920} />
		</g>
		<g id="coporate_m" data-name="coporate m">
			<path
				className="cls-corp-m-grey-green-2"
				d="M519.8,1728.56l1.76,60.32s14.73,37.89,14.73,46.31a51.57,51.57,0,0,1-2.1,14.74s-25.26,12.62-54.73,12.62-58.94-12.62-58.94-12.62-4.21-23.16,0-29.47,25.26-61,25.26-61l1.56-29.7,30-8.19Z"
			/>
			<path
				className="cls-corp-m-grey-green-2"
				d="M607.74,1728.56,606,1788.88s-14.73,37.89-14.73,46.31a51.34,51.34,0,0,0,2.11,14.74s25.25,12.62,54.72,12.62S707,1849.93,707,1849.93s4.21-23.16,0-29.47-25.26-61-25.26-61l-1.55-29.7-30-8.19Z"
			/>
			<path
				className="cls-corp-m-grey-green-3"
				d="M407.89,946.94s-8.42,117.87-8.42,143.13,18.95,223.11,14.74,246.27-12.63,162.07-4.21,221S431.05,1730,431.05,1730s21.05,14.73,61,10.52S525.77,1730,525.77,1730s-2.11-286.26-4.21-305.21,14.73-42.1,16.83-94.72,21.05-246.27,21.05-246.27,0-6.31,2.11-6.31h2.1l-.13-122Z"
			/>
			<path
				className="cls-corp-m-grey-green-3"
				d="M727.83,1090.07c0-25.26-8.42-143.13-8.42-143.13l-155.62,8.47-.14,122h2.11c2.1,0,2.1,6.31,2.1,6.31s18.95,193.65,21,246.27,19,75.78,16.84,94.72S601.54,1730,601.54,1730s-6.31,6.31,33.68,10.52,61-10.52,61-10.52,12.63-113.66,21-172.6,0-197.86-4.21-221S727.83,1115.33,727.83,1090.07Z"
			/>
			<g className="cls-corp-m-grey-green-4">
				<path
					className="cls-corp-m-grey-green-6"
					d="M715.2,553.33S724.87,680,726,683c9.55.86,99-44,99-44,0-8.42-43.67-194.66-48.76-209.86-4.94-14.77-21.12-29.59-31.57-35.78-7.68-4.55-90.51-40-101-44.2,0-2.11,0-4.21-2.11-8.42-4.21-4.21-23.15-13.9-23.15-13.9,0,7.58,8.83,13.5,10.52,16-.41,15.13-8.42,29.47-23.15,48.41s-42.1,16.84-42.1,16.84-27.36,2.11-42.09-16.84S498.82,358,498.4,342.84c1.69-2.5,10.53-8.42,10.53-16,0,0-18.95,9.69-23.16,13.9-2.1,4.21-2.1,6.31-2.1,8.42-10.53,4.21-93.35,39.65-101,44.2-10.44,6.19-26.63,21-31.57,35.78C346,444.34,312.22,633,312.22,641.44c0,0,82.23,33.42,91.78,32.56,1.13-3,8.1-120.67,8.1-120.67s4.21,256.79-2.1,284.15-4.21,109.46-4.21,109.46,75.77,37.89,157.86,37.89,157.87-37.89,157.87-37.89,2.1-82.09-4.21-109.46S715.2,553.33,715.2,553.33Z"
				/>
				<path
					className="cls-corp-m-grey-green-5"
					d="M406,638s-76.48-49.37-87-62-5.51,46.75-5.51,46.75L397,677Z"
				/>
				<path
					className="cls-corp-m-grey-green-5"
					d="M722,638s73.48-45.37,84-58,10.51,38.75,10.51,38.75L726,676Z"
				/>
				<path
					className="cls-corp-m-grey-green-5"
					d="M562.15,408.15s-21.65,10.47-25.86,31.51c-23.15-14.73-48.41-50.51-50.52-65.25s-2.1-46.3-2.1-46.3l33.68-8.42Z"
				/>
				<path
					className="cls-corp-m-grey-green-5"
					d="M565.76,408.15s21.65,10.47,25.86,31.51c23.15-14.73,48.41-50.51,50.52-65.25s2.1-46.3,2.1-46.3l-33.68-8.42Z"
				/>
				<path
					className="cls-corp-m-grey-green-5"
					d="M723,921c-37.69,25-160.35,38.3-160.35,38.3s-120.37-13-158.06-38.1c.2,10.74-5.12,32-5.12,32l153.66,44.2,10.52-9,10.53,9,153.65-44.2S722.8,931.73,723,921Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesCorporateMaleGreyGreen;
